// Images des blocs (rail de la barre latérale). Logos d'ères TCGdex pour les
// grandes époques ; pour Diamant & Perle, EX, Wizards et les Produits
// spéciaux, images fournies par l'utilisateur le 2026-09-26 (les logos
// d'ères TCGdex de ces blocs n'étaient que ceux d'un set précis).
import me from "../assets/eras/me.png";
import sv from "../assets/eras/sv.png";
import swsh from "../assets/eras/swsh.png";
import sm from "../assets/eras/sm.png";
import xy from "../assets/eras/xy.png";
import bw from "../assets/eras/bw.png";
import hgss from "../assets/eras/hgss.png";
import dp from "../assets/eras/dp.png";
import ex from "../assets/eras/ex.png";
import wizard from "../assets/eras/wizard.png";
import special from "../assets/eras/special.png";

export const ERA_IMAGE = {
  me, sv, swsh, sm, xy, bw, hgss, dp, ex, wizard,
  other: special,   // « Autre » : promos, POP, jumbos, kits, McDo, WC, Produits spéciaux, Pocket…
};

// Blocs sans image d'ère propre : on prend le LOGO d'un de leurs sets (servi
// par TCGdex/Pokécardex via useSetAsset), comme demandé par l'utilisateur le
// 2026-09-26 — Platine = logo du set Platine de base, Appel des Légendes =
// logo du set L'Appel des Légendes.
export const ERA_LOGO_SET = {
  pl: "pl1",
  col: "col1",
  tcgp: "A1",
};

// Blocs regroupés sous l'ère « Autre » dans le rail (un bouton chacun rendait
// le rail illisible sur PC — 20 tuiles dont 9 en texte). Ils restent des
// blocs à part entière ailleurs (Réglages, accueil) ; seule la barre
// latérale les range ensemble, en sections nommées.
export const OTHER_ERA_BLOCS = new Set(["promos", "ligue", "jumbo", "tk", "mc", "wc", "tcgp"]);

export const ERA_SHORT = {
  col: "CL", pl: "PL", promos: "Promo", ligue: "POP", jumbo: "Jumbo",
  tk: "Kit", mc: "McDo", tcgp: "Pocket", wc: "WC", other: "Autre",
};
